import React from "react";
import {Close, LinkSharp, WhatsApp} from "@material-ui/icons";
import {Instagram, Phone, PhoneCall, Share2} from "react-feather";
import {Col, NavLink, Row} from "reactstrap";
import logo from "../../../assets/img/logo/logo1.webp";
import {FaInstagram} from "react-icons/fa";
import {FaTelegramPlane} from "react-icons/fa";
import Technical from "../../../assets/img/logo/Technical professional.png";
import {FiPhoneCall, FiYoutube} from "react-icons/fi";
import {MdOutlineWhatsapp} from "react-icons/md";
import zarin from "../../../assets/img/elements/zarin.png"
import sazmanFny from "../../../assets/img/elements/sazmanFny.webp"
import data from "../../../assets/data/configs/storeConfig.json"
import {connect} from "react-redux";
import RenderMedia from "../../media/renderMedia";
import {Link} from "react-router-dom";
import {history} from "../../../history";
import {BiSupport} from "react-icons/bi";


class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            whatsapp: false,
            enamad: true,
            quick_access: this.props.UI.menu ? this.props.UI.menu : [],
            courses: this.props.UI.courses ? this.props.UI.courses : [],
            banners: this.props.UI.sections ? this.props.UI.sections : [],

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.UI !== prevProps.UI)) {
            this.setState({
                quick_access: this.props.UI.menu ? this.props.UI.menu : [],
                courses: this.props.UI.courses ? this.props.UI.courses : [],
                banners: this.props.UI.sections ? this.props.UI.sections : [],


            })
        }
    }

    support = () => {
        this.setState({
            whatsapp: !this.state.whatsapp,
        })
    }
    handleSupport = (targetPath) => {
        if (targetPath) history.push(targetPath)
        this.setState({
            support: !this.state.support,
        })
    }

    render() {
        return (
            <>
                <div className="web-footer">
                    <div className='web-footer-top m-auto rounded d-flex align-items-center justify-content-around p-4'>
                        <div>
                            <span className='h2 text-white'>جهت کسب اطلاعات بیشتر با ما در تماس باشید.</span>
                        </div>
                        <div>
                            <a href={`tel:${data.mobile[0]}`}>
                                <button className="btn">
                                    <FiPhoneCall/>
                                    {data.mobile[0]}
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className="bg-black-footer ">
                        <Row>
                            <Col md={5} sm={12}>
                                <div className='footer-logo'>

                                    <h4>{data.footerName}</h4>
                                </div>
                                <div className='footer-desc'>
                                    <p>
                                        گروه تخصصی خدمات مالی دریک متشکل از کارگروه‌های حسابرسی، مالیاتی، حسابداری، بیمه، آموزش و بازارهای مالی بین‌المللی می باشد که با رویکردی جامع، دقیق و راهبردی، کسب ‌وکارهای ایرانی و بین‌المللی را در مسیر رعایت مقررات، بهبود کارایی و رشد پایدار همراهی می کند. تعهد ما صحت و شفافیت در گزارشات، پشتیبانی تحلیلی و عملیاتی از آغاز شکل‌گیری تا اجرای راهکار با رعایت استانداردها و مطابق با قوانین داخلی و بین‌المللی است. ما در گروه تخصصی خدمات مالی دریک با ترکیب تخصصی عمیق و تجربه عملی در حوزه های مختلف، رویکردی شخصی‌سازی شده براساس نیازهای کسب‌وکار شما، نتیجه‌گرا، کارآمد و با تمرکز بر ارزش افزوده ارائه می‌کنیم.
                                    </p>
                                </div>
                            </Col>
                            <Col md={7} sm={12}>
                                <Row>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>لینک دسترسی سریع</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                 this.state.quick_access?.filter(item => item?.parentId === "main").map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        {item.type === 1 && <Link to={item.url}>{item.title}</Link>}
                                                    </div>
                                                ))
                                            }
                                            <div className='footer-link-speeed'>
                                                 <Link to={"/gallery"}>گالری</Link>
                                            </div>
                                            <div className='footer-link-speeed'>
                                                <Link to={"/rules"}>قوانین و مقررات</Link>
                                            </div>

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>خدمات</h5>
                                        <div className='footer-speed-container'>
                                            {
                                                this.state.banners?.slice(0, 5)?.map((item) => (
                                                    <div className='footer-link-speeed'>
                                                        <Link to={item.link}> {item.title} </Link>
                                                    </div>
                                                ))
                                            }

                                        </div>
                                    </Col>
                                    <Col md={3} sm={12}>
                                        <h5 className='title-footer'>ارتباط با ما</h5>

                                        {
                                            data.address &&  <div className='footer-location'>
                                                <span>آدرس: </span>
                                                {data.address && <p>{data.address}</p>}
                                            </div>
                                        }


                                        <div className='footer-phone my-1'>
                                            <span>تلفن: </span>
                                            {data.mobile?.map(item => (
                                                <a href={`tel:${item}`}>
                                                    <Phone/> {item}
                                                </a>
                                            ))}
                                        </div>
                                        <div className='footer-social'>
                                            {
                                                <RenderMedia />
                                            }
                                        </div>
                                    </Col>

                                    <Col md={3} sm={12}>
                                        <Row className={"footer-item-nemad"}>
                                            {
                                                data?.ifeameLink &&                    <iframe
                                                    className="map-contact"
                                                    src={data.ifeameLink}
                                                    title={`مشاهده «${data.name}»`}
                                                    width="600"
                                                    height="450"
                                                    style={{width: "100%", height: "auto", border: "0"}}></iframe>
                                            }
                                        {/*    <Col xs={6}>
                                                    <div className=" nemad-box">
                                                    <a referrerPolicy='origin' target='_blank'
                                                       className=''
                                                       href={data.enamadLink}><img
                                                        referrerPolicy='origin'
                                                        src={data.enamadImageLink}
                                                        alt='' style={{cursor: 'pointer'}} Code={data.enamadCode}/></a>
                                                </div   >
                                            </Col>*/}
                                            <Col xs={6}>
                                                    <div className='nemad-box '>
                                                        <img src={sazmanFny}/>
                                                    </div>
                                            </Col>
                                            <Col xs={6}>
                                                <div className='nemad-box '>
                                                    <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=643764&Code=gsXA5P3RuSECq8dL6o8hpdKnwwezUK0l'>
                                                        <img referrerpolicy='origin'
                                                             src='https://trustseal.enamad.ir/logo.aspx?id=643764&Code=gsXA5P3RuSECq8dL6o8hpdKnwwezUK0l'
                                                             alt='' style={{cursor: 'pointer'}}
                                                             code='gsXA5P3RuSECq8dL6o8hpdKnwwezUK0l'
                                                        />
                                                    </a>
                                                </div>
                                            </Col>
                                            <Col xs={6}>
                                               <a target='_blank' href={"https://www.zarinpal.com/trustPage/darikacademy.com"}>
                                                   <div className=' nemad-box '>
                                                       <img src={zarin} alt={"zarin-pal"}/>
                                                   </div>
                                               </a>
                                            </Col>

                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </div>

                    <div className='border-footer'></div>

                    <div className="copyright p-1 w-100 m-auto">
                        <p className="m-0">
                            {'کلیه حق و حقوق وبسایت برای '}
                            <a href={data.url}>
                                <strong className='text-bold'>
                                    {data.faName}
                                </strong>
                            </a>
                            {' محفوظ است. '}
                        </p>
                        <p className="m-0">
                            {'این وبسایت توسط شرکت باران | '}
                            <a href="https://barantm.com/landing/educational-website-design">
                                <strong className='text-bold'>
                                    طراحی سایت آموزشی
                                </strong>
                            </a>
                            {' طراحی و تولید شده است.'}
                        </p>
                    </div>

                </div>
                <div className="div-contact">
                    <div className={this.state.support ? "hidden-support open" : "hidden-support"}>
                        <div className="title-support">
                            <h2> تماس و پشتیبانی</h2>
                            <hr/>
                            <div className='text-center text-dark'>
                                <div className='button-support d-flex flex-column align-items-center '>
                                  <div className='phone-btn'>
                                      {data.mobile.map((item)=>(
                                          <NavLink
                                              href={`tel: ${item}`}
                                              target="_blank" title={item} rel="noopener noreferrer">
                                              {item}
                                              <Phone/>
                                          </NavLink>
                                      ))}
                                      <span className="top"></span>
                                      <span className="right"></span>
                                      <span className="bottom"></span>
                                      <span className="left"></span>
                                  </div>
                                   <div className='media-icon'>
                                        <div>
                                            <hr/>
                                            <h2> مارا در شبکات اجتماعی دنبال کنید.</h2>
                                        </div>
                                     <div className='d-flex align-items-center justify-content-center'>
                                         <RenderMedia/>
                                     </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="btn-contact" onClick={() => {
                        this.handleSupport()
                    }} title="تماس و پشتیبانی" aria-label="تماس و پشتیبانی">
                        {this.state.support ?
                            <Close/>
                            :
                            <BiSupport/>
                        }
                    </button>
                </div>
                <div className="copyright copyright-phone p-1 w-100 m-auto">
                    <p className="m-0">
                        کلیه حق و حقوق وبسایت برای {data.faName} محفوظ است
                    </p>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UI: state.UI
    }
}

export default connect(mapStateToProps)(Footer);
